module.exports = __webpack_public_path__ + "media/images/service/n_9-086637ab795c6e7dd7fa46f7bf1b0901.jpg";